@if (step) {
  <div
    [ngClass]="{
      'bubble-wrap': true,
      'rtl': rtl,
      'moti': step.createdByProvider,
      'stagger': stagger
    }"
  >
    @if (text) {
      <div
        class="bubble"
        [class.alternate]="step.isAlternate"
      >
        <markdown
          katex
          [data]="text"
        ></markdown>
      </div>
    }

    @if (files) {
      @for (file of files; track file) {
        <div class="bubble">
          @if (dataSourceMap[file.dataSourceId]) {
            <div
              class="source-info"
              [class.deleted]="dataSourceMap[file.dataSourceId].deletedAt"
            >
              <div>
                <strong>Source Added:</strong>
                {{ dataSourceMap[file.dataSourceId]?.name }}
                <moti-download-source-icon
                  [dataSourceId]="file.dataSourceId"
                ></moti-download-source-icon>
              </div>
            </div>

            @if ($safeNavigationMigration(dataSourceMap[file.dataSourceId]?.deletedAt) === null) {
              <div class="summary">
                <moti-summary-loader
                  [dataSource]="dataSourceMap[file.dataSourceId]"
                ></moti-summary-loader>
              </div>
            }
          } @else if (canViewDataSources) {
            <div class="source-info deleted">
              A source was added but is no longer available

              <moti-info-circle
                [infoText]="'This source was deleted after it was added to the convo. Moti won\'t know about it if you reference it.'"
              ></moti-info-circle>
            </div>
          } @else {
            <div class="source-info unauthorized">
              A source was added

              <moti-info-circle
                [infoText]="'A source was added but you do not have permission to view sources added to this convo.'"
              ></moti-info-circle>
            </div>
          }
        </div>
      }
    }

    @if (showMetadata) {
      <moti-convo-step-metadata
        [step]="step"
        [showModel]="showModel"
        [readyToAction]="readyToAction"
        [isLatestStep]="isLatestStep"
        [user]="user"
        [rtl]="rtl"
        [addingStep]="addingStep"
        [deletingStep]="deletingStep"
        (clickedAdd$)="clickedAdd$.emit($event)"
        (clickedDelete$)="clickedDelete$.emit($event)"
      ></moti-convo-step-metadata>
    }
  </div>
}
